<div class="pages">
	<div class="pages-box">
	  <div *ngFor="let page of pages" (click)="slideTo(page)" class="page" [ngClass]="{'active': pageActive === page}">{{page}}</div>
	</div>
</div>